module.exports = __webpack_public_path__ + "static/media/clients.6638090a.svg";